// extracted by mini-css-extract-plugin
export default {"header":"MpwxEoQggPhAxA0","inner":"ji3qEqSe5HL7_Cq","transitioned":"jOIxJrs437lBNra","title":"xkqMWWYA_UHFjoC","tab":"iFF_bAy7DWVpWrA","active":"bESus2SCHjyEuu0"};